"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaderboards = exports.getCourses = exports.getLessons = exports.getTournaments = exports.getChallenges = exports.getAssessments = void 0;
var contentData_1 = require("../../interfaces/contentData");
var assessmentResponse = {
    assessments: [
        {
            _id: '636b793e8408832e2f04b2dc',
            platformId: 88,
            platformUuid: '1b70e392-b2f9-4179-8cb1-7aa9ff97f62e',
            tenant: 'management',
            licenseId: 2,
            categories: [
                {
                    name: 'injection',
                    displayName: 'Injection',
                },
                {
                    name: 'sensitive_data_exposure',
                    displayName: 'Sensitive Data Exposure',
                },
                {
                    name: 'csrf',
                    displayName: 'Cross Site Request Forgery',
                },
                {
                    name: 'xss',
                    displayName: 'Cross-Site Scripting',
                },
            ],
            endDate: new Date(),
            name: 'assessment 1',
            startDate: new Date(),
        },
        {
            _id: '636b793e8408832e2f04b233',
            platformId: 88,
            platformUuid: '1b70e392-b2f9-4179-8cb1-7aa9ff97f633',
            tenant: 'management',
            licenseId: 2,
            categories: [
                {
                    name: 'injection',
                    displayName: 'Injection',
                },
                {
                    name: 'sensitive_data_exposure',
                    displayName: 'Sensitive Data Exposure',
                },
            ],
            endDate: new Date(),
            name: 'assessment 2',
            startDate: new Date(),
        },
    ],
};
var tournamentResponse = {
    tournaments: [
        {
            _id: '633ad2798408833127034504',
            platformId: 24,
            platformUuid: 'b35ae1c6-4f37-4285-a2f4-55742bb08580',
            tenant: 'management',
            licenseId: 2,
            iconUrl: 'tournament-16',
            name: 'tournament 1',
            scheduledDateTime: new Date(),
            status: 'pending',
        },
        {
            _id: '633ad2798408833127034533',
            platformId: 24,
            platformUuid: 'b35ae1c6-4f37-4285-a2f4-55742bb08533',
            tenant: 'management',
            licenseId: 2,
            iconUrl: 'tournament-10',
            name: 'tournament 2',
            scheduledDateTime: new Date(),
            status: 'pending',
        },
    ],
};
var leaderboardResponse = {
    leaderboards: [
        {
            _id: '633ad2798408836211380ae8',
            tenant: 'management',
            licenseId: 2,
            type: contentData_1.LeaderboardType.TEAMS,
            data: [
                {
                    rank: 1,
                    name: 'test team',
                    numOfMembers: 1,
                    score: 50,
                },
            ],
        },
        {
            _id: '633ad27984088338f72f1715',
            tenant: 'management',
            licenseId: 2,
            type: contentData_1.LeaderboardType.USERS,
            data: [
                {
                    rank: 1,
                    score: 307856,
                    emailAddress: 'user1@codebashing.com',
                },
                {
                    rank: 2,
                    score: 46233,
                    emailAddress: 'user2@codebashing.com',
                },
                {
                    rank: 3,
                    score: 40000,
                    emailAddress: 'user3@codebashing.com',
                },
                {
                    rank: 4,
                    score: 10667,
                    emailAddress: 'user4@codebashing.com',
                },
                {
                    rank: 5,
                    score: 9250,
                    emailAddress: 'user5@codebashing.com',
                },
            ],
        },
    ],
};
var challengesResponse = {
    challenges: [
        {
            _id: '633ad27284088362167a1ce1',
            platformId: 1,
            uuid: 'b35ae1c6-4f37-4285-a2f4-55742bb0999',
            displayName: 'Fundamental Challenge for Android',
            enabled: true,
            language: 'Android',
            level: 'Basic',
        },
        {
            _id: '633ad27284088339a20efc90',
            platformId: 2,
            uuid: 'b35ae1c6-4f37-4285-a2f4-55742bb0555',
            displayName: 'Fundamental Challenge for C/C++',
            enabled: true,
            language: 'C/C++',
            level: 'Basic',
        },
    ],
};
var coursesResponse = {
    courses: [
        {
            _id: '633ad27684088331270344ac',
            name: 'management_mm_1606903805',
            tenant: 'management',
            platformUuid: null,
            description: 'desc1',
            displayName: 'course 1',
            iconUrl: 'https://s3/customCourse-2.svg',
            numberOfLessons: 9,
            type: true,
        },
        {
            _id: '633ad27684088362167a1ce8',
            name: 'angular_js',
            tenant: '',
            platformUuid: '8a180a03-5c66-459c-aae1-602163656b6d',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            displayName: 'AngularJS',
            iconUrl: 'https://s3/courses-assets/angular.svg',
            numberOfLessons: 8,
            type: false,
        },
    ],
};
var lessonsResponse = {
    lessons: [
        {
            _id: '633ad27684088362167a1cfc',
            name: 'lesson1_1111647340670',
            tenant: 'management',
            courseName: 'custom_lessons',
            active: true,
            courseDisplayName: 'Custom Lessons',
            description: 'desc 1',
            displayName: 'Lesson 1',
            duration: 45,
            iconUrl: 'www.icon-url.com',
            type: true,
        },
    ],
};
var getAssessments = function () { return assessmentResponse; };
exports.getAssessments = getAssessments;
var getChallenges = function () { return challengesResponse; };
exports.getChallenges = getChallenges;
var getTournaments = function () { return tournamentResponse; };
exports.getTournaments = getTournaments;
var getLessons = function () { return lessonsResponse; };
exports.getLessons = getLessons;
var getCourses = function () { return coursesResponse; };
exports.getCourses = getCourses;
var getLeaderboards = function () { return leaderboardResponse; };
exports.getLeaderboards = getLeaderboards;
